function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import moment from 'moment';
import pick from 'ramda/src/pick';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
import { getQService } from 'invision-core/src/components/injectables/injector.helper';
import { getContentTypeFromFileType, getFileTypeFromContentType } from 'invision-core/src/components/upload/upload.helper';
import UploadHelperConstants from 'invision-core/src/components/upload/upload.helper.constants';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { addImportBulkServiceAttributesJobPendingFile, clearImportBulkServiceAttributesJobPendingFiles, removeImportBulkServiceAttributesJobPendingFile, retrieveAwsS3UploadConfiguration, retrieveImportBulkServiceAttributesJobDetails, sendBulkServiceAttributesUploadNotification, setIsImportingBulkServiceAttributes, updateImportBulkServiceAttributesJobPendingFileStatus, updateImportBulkServiceAttributesJobsPendingUpdatedStatus } from '../../../../../reducers/actions/order.details.actions';
import { retrieveConvergentBillerOrderDetails } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { IMPORT_BULK_SERVICE_ATTRIBUTES_ALLOWED_FILE_TYPE_NAME, IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_STATUSES, IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES, MAX_NUM_IMPORT_UPLOADABLE_FILES } from '../order.details.constants';
import { OrderDetailsImportServiceAttributesFormEditingIsDisabledSelector, OrderDetailsImportServiceAttributesFormSubmissionIsDisabledSelector, OrderDetailsImportServiceAttributesJobDetailsViewModelSelector, OrderDetailsImportServiceAttributesJobsPendingUpdatedStatusSelector, OrderDetailsBulkServiceAttributesJobIsImportingSelector, OrderDetailsBulkServiceAttributesJobIsProcessingSelector, OrderDetailsImportServiceAttributesUploadConfigurationSelector } from '../../../../../reducers/selectors/order.details.selectors';
import { CurrentOrderItemDisplayItemsSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { generateFormattedFileResult } from './import.bulk.attributes.modal.helper';
var ImportBulkAttributesModalController = /*#__PURE__*/function () {
  function ImportBulkAttributesModalController($ngRedux, uiNotificationService) {
    _classCallCheck(this, ImportBulkAttributesModalController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $q: getQService(),
      coreLocaleKeys: CoreLocaleKeys,
      i18n: i18n,
      localeKeys: CustomerCareLocaleKeys,
      uiNotificationService: uiNotificationService,
      viewModel: {
        isLoading: true,
        orderDetails: {
          files: [],
          invalidFiles: [],
          offeringId: null
        }
      }
    });
  }
  return _createClass(ImportBulkAttributesModalController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var ALLOWED_FILE_TYPE = UploadHelperConstants.ALLOWED_FILE_TYPES_MAPPING[IMPORT_BULK_SERVICE_ATTRIBUTES_ALLOWED_FILE_TYPE_NAME];
      var controllerActions = {
        addImportBulkServiceAttributesJobPendingFile: addImportBulkServiceAttributesJobPendingFile,
        clearImportBulkServiceAttributesJobPendingFiles: clearImportBulkServiceAttributesJobPendingFiles,
        removeImportBulkServiceAttributesJobPendingFile: removeImportBulkServiceAttributesJobPendingFile,
        retrieveAwsS3UploadConfiguration: retrieveAwsS3UploadConfiguration,
        retrieveConvergentBillerOrderDetails: retrieveConvergentBillerOrderDetails,
        retrieveImportBulkServiceAttributesJobDetails: retrieveImportBulkServiceAttributesJobDetails,
        sendBulkServiceAttributesUploadNotification: sendBulkServiceAttributesUploadNotification,
        setIsImportingBulkServiceAttributes: setIsImportingBulkServiceAttributes,
        updateImportBulkServiceAttributesJobPendingFileStatus: updateImportBulkServiceAttributesJobPendingFileStatus,
        updateImportBulkServiceAttributesJobsPendingUpdatedStatus: updateImportBulkServiceAttributesJobsPendingUpdatedStatus
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          bulkServiceAttributesJobsPendingUpdatedStatus: OrderDetailsImportServiceAttributesJobsPendingUpdatedStatusSelector(store),
          currentOrderDisplayItems: CurrentOrderItemDisplayItemsSelector(store),
          isFormEditingDisabled: OrderDetailsImportServiceAttributesFormEditingIsDisabledSelector(store),
          isFormSubmissionDisabled: OrderDetailsImportServiceAttributesFormSubmissionIsDisabledSelector(store),
          isImportingServiceAttributes: OrderDetailsBulkServiceAttributesJobIsImportingSelector(store),
          isProcessingServiceAttributes: OrderDetailsBulkServiceAttributesJobIsProcessingSelector(store),
          jobDetailsViewModel: OrderDetailsImportServiceAttributesJobDetailsViewModelSelector(store),
          uploadConfig: OrderDetailsImportServiceAttributesUploadConfigurationSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.uploadErrorCallback = function (response) {
        var translatedErrorMessage = _this.i18n.translate(_this.coreLocaleKeys.UPLOAD.AWS_ERRORS.DEFAULT);
        _this.actions.updateImportBulkServiceAttributesJobPendingFileStatus(response.fileName, generateFormattedFileResult(IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.FAILURE, translatedErrorMessage));
      };
      this.uploadSuccessCallback = function (response) {
        var fileDetails = {
          name: response.fileName,
          path: response.filePath
        };
        var orderDetails = pick(['jobId', 'orderId', 'pricingPlanId', 'subscriberId'], _this.state.jobDetailsViewModel);
        orderDetails.offeringId = _this.viewModel.orderDetails.offeringId;
        _this.sendBulkServiceAttributesUploadNotification(orderDetails, fileDetails);
      };

      // NOTE: Standardize the file type since OS/browsers aren't consistent with content-types (e.g. a CSV may be "application/vnd.ms-excel"
      // if associated with Excel instead of "text/csv")
      this.validateFile = function (selectedFile) {
        var selectedFileType = getFileTypeFromContentType(selectedFile.type);
        return !!(selectedFileType && ALLOWED_FILE_TYPE.type === selectedFileType);
      };
      this.customErrorMessageLocaleKeysMapping = {
        maxFiles: this.i18n.translate(this.coreLocaleKeys.UPLOAD.MAX_NUM_FILES, {
          numFiles: MAX_NUM_IMPORT_UPLOADABLE_FILES
        }),
        maxSize: this.i18n.translate(this.coreLocaleKeys.UPLOAD.MAX_FILE_SIZE),
        validateFn: this.i18n.translate(this.localeKeys.ORDER_DETAILS.IMPORT_BULK_SERVICE_ATTRIBUTES.FILE_TYPE_ERROR, {
          fileType: ".".concat(ALLOWED_FILE_TYPE.extension)
        })
      };
      this.fileUploadConfig = {
        allowedFileTypeExtension: ".".concat(ALLOWED_FILE_TYPE.extension),
        allowedFileTypeId: ALLOWED_FILE_TYPE.typeId,
        allowInvalidFilesInModel: false,
        maxNumFiles: MAX_NUM_IMPORT_UPLOADABLE_FILES
      };
      this.modalTitle = "".concat(this.i18n.translate(this.localeKeys.ORDER_DETAILS.IMPORT_SERVICE_ATTRIBUTES), ": ").concat(this.orderDetails.pricingPlanName);
      this.actions.retrieveImportBulkServiceAttributesJobDetails(this.orderDetails).then(function () {
        var pendingJobDetails = _this.state.bulkServiceAttributesJobsPendingUpdatedStatus[_this.orderDetails.pricingPlanId];
        _this.viewModel.isLoading = false;
        _this.viewModel.orderDetails.offeringId = _this.orderDetails.offeringId;
        if (pendingJobDetails && _this.state.jobDetailsViewModel.importHistorySummary.dateLastModified > pendingJobDetails.dateLastModified) {
          _this.actions.updateImportBulkServiceAttributesJobsPendingUpdatedStatus([{
            pricingPlanId: _this.orderDetails.pricingPlanId
          }]);
        }
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.clearImportBulkServiceAttributesJobPendingFiles();
      this.disconnectRedux();
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.state.isImportingServiceAttributes) {
        this.resetFormState(true);
        this.onClose()();
      }
    }
  }, {
    key: "displayOverrideMessage",
    value: function displayOverrideMessage() {
      return !this.state.jobDetailsViewModel.pendingUpdatedStatus && !this.state.isProcessingServiceAttributes && this.state.jobDetailsViewModel.statusId !== IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_STATUSES.FINISHED_WITH_ERRORS;
    }
  }, {
    key: "displayServiceAttributesJobCompleteMessage",
    value: function displayServiceAttributesJobCompleteMessage() {
      return this.state.isFormEditingDisabled && this.state.isFormSubmissionDisabled && this.state.jobDetailsViewModel.statusId === IMPORT_BULK_SERVICE_ATTRIBUTES_JOB_STATUSES.FINISHED_WITH_ERRORS;
    }
  }, {
    key: "extendFileModel",
    value: function extendFileModel(files, file) {
      if (file) {
        if (!file.importResults) {
          file.importResults = [];
        }
        this.actions.addImportBulkServiceAttributesJobPendingFile(file);
      }
    }
  }, {
    key: "uploadFileToAwsS3Bucket",
    value: function uploadFileToAwsS3Bucket(utcDateAndTime, file) {
      var _this2 = this;
      var fileName = "".concat(utcDateAndTime, "-").concat(file.name);
      this.actions.retrieveAwsS3UploadConfiguration(fileName, this.fileUploadConfig.allowedFileTypeId, this.orderDetails.orderId, this.orderDetails.pricingPlanId, this.orderDetails.customerId).then(function () {
        var fileType = getFileTypeFromContentType(file.type);
        var fileContentType = getContentTypeFromFileType(fileType);
        fetch(_this2.state.uploadConfig.SignedUrl, {
          body: file,
          method: 'PUT',
          headers: {
            'Content-Type': fileContentType
          }
        }).then(function () {
          _this2.uploadSuccessCallback({
            fileName: file.name,
            filePath: _this2.state.uploadConfig.DestinationFilePath
          });
        }).catch(function () {
          _this2.uploadErrorCallback({
            fileName: file.name
          });
        });
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "handleRemoveFile",
    value: function handleRemoveFile(file) {
      if (!this.state.isFormSubmissionDisabled) {
        this.actions.removeImportBulkServiceAttributesJobPendingFile(file.name);
        if (!this.state.jobDetailsViewModel.pendingFiles.length) {
          this.resetFormState(true);
        }
      }
    }
  }, {
    key: "handleUploadNotificationResponse",
    value: function handleUploadNotificationResponse(orderDetails, fileDetails, error) {
      var formattedResult;
      if (!error) {
        formattedResult = generateFormattedFileResult(IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.SUCCESS, i18n.translate(this.localeKeys.ORDER_DETAILS.IMPORT_BULK_SERVICE_ATTRIBUTES.FILE_IMPORTED_SUCCESSFULLY));
      } else {
        formattedResult = generateFormattedFileResult(IMPORT_BULK_SERVICE_ATTRIBUTES_UPLOAD_STATUSES.FAILURE, error.translatedMessage);
      }
      this.actions.updateImportBulkServiceAttributesJobPendingFileStatus(fileDetails.name, formattedResult);
      this.actions.setIsImportingBulkServiceAttributes(false);
      if (!error) {
        this.resetFormState();
      }
      this.actions.retrieveConvergentBillerOrderDetails(orderDetails.subscriberId, orderDetails.orderId);
    }
  }, {
    key: "resetFormState",
    value: function resetFormState() {
      var includeSelectedFiles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (includeSelectedFiles) {
        this.viewModel.orderDetails.files = [];
        this.viewModel.orderDetails.invalidFiles = [];
      }
      this.importBulkServiceAttributesForm.$setPristine();
      this.importBulkServiceAttributesForm.$setUntouched();
    }
  }, {
    key: "sendBulkServiceAttributesUploadNotification",
    value: function sendBulkServiceAttributesUploadNotification(orderDetails, fileDetails) {
      var _this3 = this;
      this.actions.sendBulkServiceAttributesUploadNotification(orderDetails, fileDetails).then(function () {
        _this3.handleUploadNotificationResponse(orderDetails, fileDetails);
      }, function (error) {
        _this3.handleUploadNotificationResponse(orderDetails, fileDetails, error);
      });
    }

    // NOTE: `this.viewModel.orderDetails.files` is used instead of `this.state.jobDetailsViewModel.pendingFiles`
    // below since the File object properties are stripped by Immutable when adding to the store. Otherwise they should
    // be in sync
  }, {
    key: "submit",
    value: function submit() {
      var _this4 = this;
      if (this.importBulkServiceAttributesForm.$valid && this.viewModel.orderDetails.files.length) {
        this.actions.setIsImportingBulkServiceAttributes(true);
        var utcDateAndTime = moment().utc().format(moment.defaultFormatUtc);
        this.viewModel.orderDetails.files.forEach(function (file) {
          _this4.uploadFileToAwsS3Bucket(utcDateAndTime, file);
        });
      }
    }
  }]);
}();
export default {
  bindings: {
    onClose: '&',
    orderDetails: '<'
  },
  controller: ImportBulkAttributesModalController,
  controllerAs: 'ctrl',
  template: require('./import.bulk.attributes.modal.html')
};